"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cittadella": {
    "ec9697fd": [{
      "hkey": "cd4e4804",
      "slug": "facca-santa-maria",
      "name": "Facca-Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "facca": [{
      "hkey": "cd4e4804",
      "slug": "facca-santa-maria",
      "name": "Facca-Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6b4cfcf9": [{
      "hkey": "cd4e4804",
      "slug": "facca-santa-maria",
      "name": "Facca-Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "cd4e4804",
      "slug": "facca-santa-maria",
      "name": "Facca-Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cittadella"
    }]
  }
};
exports["default"] = _default;